import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { useFiles } from 'client/store'
import filesSelectors from 'client/store/files/filesSelectors'
import { EntityProps } from 'client/types'
import CommonAudio from 'common/components/entities/Audio/AudioNew'
import { AudioInterface } from 'common/types/entities/AudioInterface'
import React from 'react'

function AudioNew({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<AudioInterface>) {
  const file = useFiles(files =>
    filesSelectors.getFileById(files, entity.fileId),
  )
  const src = file?.path || entity.url || undefined

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonAudio htmlAttrId={entity.htmlAttrId} src={src} />
    </BaseEntityNew>
  )
}

export default AudioNew
